import React from 'react';

const Water = props => (
  <svg
    width={22}
    height={32}
    viewBox="0 0 22 32"
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M20.753 21c0 5.524-4.42 10-9.877 10C5.42 31 1 26.522 1 21c0-5.521 9.876-20 9.876-20s9.877 14.479 9.877 20Z"
      stroke="#FAFAFA"
      strokeLinejoin="round"
    />
    <path
      d="M10.339 25.627c-2.543 0-4.606-2.09-4.606-4.665"
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Water;
